"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function TimelineIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "7.039", y: "9.355", width: "1.904", height: "5.29" }),
        react_1.default.createElement("path", { d: "M7.871,23.207c-2.048,0-3.715-1.666-3.715-3.714s1.667-3.715,3.715-3.715,3.714,1.667,3.714,3.715-1.666,3.714-3.714,3.714Zm0-5.524c-.998,0-1.811,.812-1.811,1.811s.812,1.81,1.811,1.81,1.81-.812,1.81-1.81-.812-1.811-1.81-1.811Z" }),
        react_1.default.createElement("rect", { x: "12.476", y: "16.975", width: "7.368", height: "1.904" }),
        react_1.default.createElement("rect", { x: "12.476", y: "20.107", width: "7.368", height: "1.904" }),
        react_1.default.createElement("path", { d: "M7.871,8.222c-2.048,0-3.715-1.666-3.715-3.714S5.823,.793,7.871,.793s3.714,1.667,3.714,3.715-1.666,3.714-3.714,3.714Zm0-5.524c-.998,0-1.811,.812-1.811,1.811s.812,1.81,1.811,1.81,1.81-.812,1.81-1.81-.812-1.811-1.81-1.811Z" }),
        react_1.default.createElement("rect", { x: "12.476", y: "1.989", width: "7.368", height: "1.904" }),
        react_1.default.createElement("rect", { x: "12.476", y: "5.122", width: "7.368", height: "1.904" })));
}
exports.default = TimelineIcon;
